/* eslint-disable no-magic-numbers */

import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import wordScaleSnapInRightGif from '../../../assets/images/transitions/wordScaleSnapInRight.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_WORD_SCALE_SNAP_OUT_RIGHT = 'wordScaleSnapOutRight';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const wordScaleSnapOutRightPresetDetails = {
  // The name of the preset.
  name: PRESET_WORD_SCALE_SNAP_OUT_RIGHT,

  // A human friendly name for the preset.
  humanName: 'Word Scale & Snap Out - Right',

  // A preview of the transition.
  gif: wordScaleSnapInRightGif,

  // The element names that this preset can be used for or true for all elements.
  elements: ['text'],

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'out',

  // Each property that will change during the transition.
  details: {
    'word.scaleY': {
      time: {
        end: 'end.0',
        start: 'end.-1500'
      },
      easing: EASINGS.easeOutExpo,
      values: [
        1,
        0
      ],
      stagger: 50,
      staggerDuration: false,
      immediateRender: false
    },
    'word.translateX': {
      time: {
        end: 'end.0',
        start: 'end.-2000'
      },
      easing: EASINGS.easeInOutExpo,
      values: [
        0,
        400
      ],
      stagger: 50,
      staggerDuration: false,
      immediateRender: false
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_WORD_SCALE_SNAP_OUT_RIGHT,
    options: {},
  },
};

wordScaleSnapOutRightPresetDetails.template.options = lodash.cloneDeep(wordScaleSnapOutRightPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_WORD_SCALE_SNAP_OUT_RIGHT;

// This defines the value of the presets object.
export default wordScaleSnapOutRightPresetDetails;

